import React, { useState, useEffect, useCallback } from 'react';
import {
	TranslatedString,
	useAjax,
	XhrStatus,
	Form,
	PrimaryButton
} from '@bosch/bt-ui';

import './CSRManagementTableButton.css';
import { useNavigate } from 'react-router-dom';
import withErrorHandler from '../../components/ErrorHandler';
import ConfirmDialog from '../../components/ConfirmDialog';
import WarningDialog from '../../components/WarningDialog';
import CenterLoadingContainer from '../../components/CenterLoadingContainer';
import { prepareLogData } from '../../components/Util';

const CSRManagementTableButton = (props) => {
	const {
		token,
		isLoggedIn,
		ipAddress,
		versions,
		csrInfo,
		updateCSRInfo
	} = props;

	const navigate = useNavigate();
	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);
	const [openConfirm, setConfirmOpen] = useState(false);
	const [openWarning, setWarningOpen] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(true);

	const onOpenModal = () => setConfirmOpen(true);
	const onFormSubmit = useCallback(
		() => {
			if (isLoggedIn()) {
				const headers = {
					'Authorization': 'Bearer ' + token.token
				}

				const name = versions.find(item => { return item.value === csrInfo[ipAddress].releaseVersion; }).label;
				const data = {
					'IPAddress': ipAddress,
					'Name': name,
				}
				const datalog = prepareLogData(token,'Virtual_CSR_Management', 'Submit: Version ' + name);

				setConfirmOpen(false);
				// "Pending" means, the submit had been send to backend but not response yet, so can't accept another submit.
				var result = false;
				Object.entries(csrInfo).map(([key, value]) => {
					if (value.csrStatus === 'Pending') {
						console.log(key, value)
						setWarningOpen(true);
						result = true;
						return;
					}
				})

				if (!result) {
					// Report the process status as "Pending"
					// "Pending" means, the submit had been send to backend but not response yet, so can't accept another submit.
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'csrStatus', value:'Pending'}})
					
					setSubmitDisable(true);
					runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/' + encodeURIComponent(ipAddress) + '/upgrade', null, data, headers);
					//Add activity log
					fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + token.token
						},
						body: JSON.stringify(datalog)
					})	
				}
			}
			else {
				navigate('/');
			}
		},
		[token, runAjaxInner, ipAddress, versions, csrInfo, updateCSRInfo, isLoggedIn, navigate]
	);

	useEffect(
		() => {
			if (csrInfo[ipAddress].csrStatus !== 'Succeeded')
				setSubmitDisable(true);
			else if (csrInfo[ipAddress].releaseVersion !== csrInfo[ipAddress].oldReleaseVersion)
				setSubmitDisable(false);
			else
				setSubmitDisable(true);
		},
		[ipAddress, csrInfo]
	);

	useEffect(
		() => {
			if (returnResult && csrInfo[ipAddress].releaseVersion !== csrInfo[ipAddress].oldReleaseVersion) {
				console.log(returnResult, csrInfo[ipAddress]);
				if (returnResult.status === 'Success') {
					// Update table row information
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'name', value:returnResult.data.name}})
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'oldReleaseVersion', value:csrInfo[ipAddress].releaseVersion}})
				}
				else {
					// Recover dropdown item
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'releaseVersion', value:csrInfo[ipAddress].oldReleaseVersion}})
				}
				// Report the process status
				updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'csrStatus', value:returnResult.data.csrStatus}})

				// Not sure how to reset returnResult
				runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/reset', null, null,  {'Authorization': 'Bearer ' + token.token});
			}
		},
		[returnResult, ipAddress, csrInfo, updateCSRInfo, runAjaxInner, token]
	);
	
	return (
		status === XhrStatus.InProgress ?
			<CenterLoadingContainer />
		:
			<Form
				formAttributes={{
					onSubmit: onOpenModal,
					method: 'post',
					action: ''
				}}
			>
				<div className="csr-update-button">
					<PrimaryButton type="submit" disabled={disableSubmit}>
						<TranslatedString stringId="button-submit" />
					</PrimaryButton>
					<ConfirmDialog openConfirm={openConfirm} descTranslatedId={'csr-update-warning'} setConfirmOpen={setConfirmOpen} onConfirm={onFormSubmit} />
					<WarningDialog openWarning={openWarning} descTranslatedId={'csr-pending-warning'} setWarningOpen={setWarningOpen} headTranslatedId={'Caution'} />
				</div>
			</Form>
	);
};

export default withErrorHandler(React.memo(CSRManagementTableButton));